import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { kebabCase } from 'lodash';
import Modal from '../Modal';
import icons from '../../assets/comet/comet.svg';
import './styles.styl';

const Card = ({ data, onClick, open, opened }) => {
  const handleClick = () => {
    onClick(data.modal.title);
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleClick();
    }
  };

  const buttonClasses = classNames(
    {
      'modal-cards__button--opened': opened
    },
    'comet-button',
    'comet-button--primary',
    'comet-button--icon-only'
  );

  /* eslint-disable jsx-a11y/no-static-element-interactions */
  return (
    <Fragment>
      <div
        className="comet-card comet-card--white modal-cards__card"
        onClick={handleClick}
        onKeyDown={handleKeyDown}
      >
        <div className="comet-card__card-anchor">
          <div className="comet-card__copy">
            <p className="comet-card__title">{data.title}</p>
            <div className="comet-thumbnail">
              <div className="comet-thumbnail__inner">
                <img alt="" height="280" src={data.image} width="402" />
              </div>
            </div>
            <footer className="modal-cards__footer">
              <button
                className={buttonClasses}
                aria-labelledby={`${kebabCase(data.title)}-button-text`}
              >
                <svg
                  className="comet-button__icon comet-button__icon--left"
                  aria-hidden="true"
                  focusable="false"
                >
                  <use xlinkHref={`${icons}${opened ? '#check' : '#plus'}`} />
                </svg>
                <span className="comet-screenreader-only">{data.text}</span>
              </button>
              <p
                id={`${kebabCase(data.title)}-button-text`}
                className="modal-cards__footer-text"
              >
                {data.text ? data.text : 'Learn More'}
              </p>
            </footer>
          </div>
        </div>
      </div>
      {open && <Modal data={data.modal} onClose={handleClick} />}
    </Fragment>
  );
  /* eslint-enable jsx-a11y/no-static-element-interactions */
};

Card.defaultProps = {
  open: false,
  opened: false
};

Card.propTypes = {
  data: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  open: PropTypes.bool,
  opened: PropTypes.bool
};

export default Card;



// WEBPACK FOOTER //
// ../core/src/components/ModalCards/Card.js